// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-0ee1d3f3]{fill:#fff}.cls-2[data-v-0ee1d3f3]{fill:var(--v-primary-base)}.cls-3[data-v-0ee1d3f3]{-webkit-filter:url(#Rechteck_317);filter:url(#Rechteck_317)}", ""]);
// Exports
module.exports = exports;
